
@if (bookType !== 'SKFRDriver') {
  <app-trainingselect></app-trainingselect>
} @else {
  <app-gatetype></app-gatetype>
}


